const HomeIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="home-icon"
  >
    <path
      d="M19 16.4298V11.6772C19 11.2194 18.9996 10.9904 18.9427 10.7774C18.8924 10.5887 18.8097 10.41 18.6977 10.2486C18.5715 10.0665 18.3959 9.91543 18.044 9.61401L13.844 6.01608C13.1907 5.45644 12.8641 5.17677 12.4965 5.07034C12.1725 4.97655 11.8273 4.97655 11.5034 5.07034C11.136 5.17669 10.8099 5.4561 10.1576 6.01489L5.95618 9.61401C5.60431 9.91543 5.42879 10.0665 5.30249 10.2486C5.19057 10.41 5.10723 10.5887 5.05685 10.7774C5 10.9904 5 11.2194 5 11.6772V16.4298C5 17.2281 5 17.6271 5.13321 17.9419C5.31083 18.3617 5.65128 18.6957 6.08008 18.8696C6.40168 19 6.80938 19 7.62477 19C8.44017 19 8.84832 19 9.16992 18.8696C9.59872 18.6957 9.93909 18.3618 10.1167 17.942C10.2499 17.6272 10.25 17.228 10.25 16.4297V15.5731C10.25 14.6268 11.0335 13.8598 12 13.8598C12.9665 13.8598 13.75 14.6268 13.75 15.5731V16.4297C13.75 17.228 13.75 17.6272 13.8832 17.942C14.0608 18.3618 14.4013 18.6957 14.8301 18.8696C15.1517 19 15.5594 19 16.3748 19C17.1902 19 17.5983 19 17.9199 18.8696C18.3487 18.6957 18.6891 18.3617 18.8667 17.9419C18.9999 17.6271 19 17.2281 19 16.4298Z"
      stroke="#2E5BE2"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default HomeIcon;
